var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ChoiceItem",class:[
        ("ChoiceItem--" + (_vm.image ? 'image' : 'text')),
        { selected: _vm.state.selected, correct: _vm.state.correct, '--global-clickable': !_vm.state.selected }
    ],style:({ backgroundImage: _vm.image ? ("url(" + _vm.image + ")") : null }),on:{"click":function($event){!_vm.state.selected && _vm.$emit('click')}}},[(!_vm.image)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }